<form class="mce-form-section">

    <div class="mce-form-field-group">

        <div class="flex min-w-0 flex-grow flex-col">

            <div class="flex-grow" [class.mce-form-field-disabled]="primaryMethodsRx.isLoading()">
                <mat-form-field class="w-full">
                    <mat-label>primary method</mat-label>
                    <mat-select [formField]="form().installation.iec60502Factors.primaryMethodGuid">
                        @for (option of primaryMethods(); track option.value) {
                        <mat-option [value]="option.value">{{option.label}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="flex-grow" [class.mce-form-field-disabled]="secondaryMethodsRx.isLoading()">
                <mat-form-field class="w-full">
                    <mat-label>secondary method</mat-label>
                    <mat-select [formField]="form().installation.iec60502Factors.secondaryMethodGuid">
                        @for (option of secondaryMethods(); track option.value) {
                        <mat-option [value]="option.value">{{option.label}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>

        </div>

        @if(viewState().hasInstallationImage){
        <div class="hidden sm:flex">
            <app-form-image [formImage]="viewState().installationImage"></app-form-image>
        </div>  }

    </div>

        <div class="mce-form-field-group">
            <app-grouping [form]="form().installation.iec60502Factors.grouping"></app-grouping>
        </div>

        <div class="mce-form-field-group">

            @if(isBuried()) {
            <app-buried [form]="form().installation.iec60502Factors.buried"></app-buried>
            }

            <app-ambient-temperature [form]="form().installation.iec60502Factors.ambientTemperature" [isBuried]="isBuried()"></app-ambient-temperature>

            @if(isOnTray()) {
            <div>
                <mat-form-field>
                    <mat-label>number of trays</mat-label>
                    <input matInput type="number" placeholder="number of trays"
                           [formField]="form().installation.iec60502Factors.numberOfTrays" />
                    <span matSuffix>trays</span>
                    @for (error of form().installation.iec60502Factors.numberOfTrays().errors(); track error.kind ) {
                    <mat-error> {{ error.message }} </mat-error> }
                </mat-form-field>
            </div>
            }


        </div>


        <div class="mce-form-field-group">
            <app-user-defined-factor [form]="form().installation.iec60502Factors.userDefinedFactor"></app-user-defined-factor>
        </div>



</form>
